const defaultApiKey = "YD9o4MFhz6axUQ7IA4xUl8YkFBO0BsgL7FqjV16D";

const baseArgs = {
	isProd: true,
	showFaqs: false,
	google: { gtmId: "GTM-N3KK6Q6" },
	callbackData: {
		endPoint: "https://ag5sh97b30.execute-api.eu-west-1.amazonaws.com/Prod",
		apiKey: defaultApiKey,
	},
	contactusData: {
		endPoint:
			"https://4qbnjdxz37.execute-api.eu-west-1.amazonaws.com/freedom-live",
		apiKey: defaultApiKey,
	},
	AxiosData: {
		endPoint:
			"https://4qbnjdxz37.execute-api.eu-west-1.amazonaws.com/freedom-live",
		apiKey: defaultApiKey,
		dateHelpers: require("@library/common/helpers/misc/date").default,
	},
	liveChat: {
		useLiveChat: true,
		environment: "prod-euw2",
		deploymentId: "61ec1566-01d4-47cd-adbd-09f7971e2ed6",
	},
	endPointsPayment: {
		baseUrl: `https://1z6xkavxp8.execute-api.eu-west-1.amazonaws.com/freedom-live`,
		apiKey: defaultApiKey,
	},
};
const baseConfig = require("../base").default(baseArgs);

export default baseConfig;
